import { getDocuments } from '../services/documents';

const getConnectorTypes = async (): Promise<any> => {
  const data = getDocuments('connector_types');
  return data;
};

export { getConnectorTypes };
